import { Icon, IconName } from '@usealloy/component-library';

export const ViewIntegrationMenuIcon = (
  <Icon icon={IconName.ArrowUpRightFromSquare} />
);
